// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"67579367","453":"1407b060","796":"977dd0c3"}[chunkId] + ".chunk.js";
};